/**
 * ACTIONS CELL
 * Cellule avec boutons d'actions (Supprimer, Voir, etc.)
 */

import { Eye, Trash2 } from 'lucide-react';

interface ActionsCellProps {
  onDelete?: () => void;
  onView?: () => void;
  canDelete?: boolean; // Permission de supprimer (par défaut: true si onDelete fourni)
  canView?: boolean; // Permission de voir (par défaut: true si onView fourni)
}

export function ActionsCell({
  onDelete,
  onView,
  canDelete = true,
  canView = true,
}: ActionsCellProps) {
  // Afficher le bouton "Voir" si la fonction est fournie ET si l'utilisateur a la permission
  const showViewButton = onView && canView;

  // Afficher le bouton "Supprimer" si la fonction est fournie ET si l'utilisateur a la permission
  const showDeleteButton = onDelete && canDelete;

  return (
    <div className="flex items-center justify-end gap-1 w-full">
      {showViewButton && (
        <button
          onClick={onView}
          className="flex items-center justify-center h-9 px-3 py-2.5 bg-white border border-zinc-200 rounded-md shadow-xs hover:bg-zinc-50 transition-colors"
          aria-label="Voir"
        >
          <Eye className="size-4 text-zinc-900" />
        </button>
      )}
      {showDeleteButton && (
        <button
          onClick={onDelete}
          className="flex items-center justify-center h-9 px-3 py-2.5 bg-white border border-zinc-200 rounded-md shadow-xs hover:bg-red-50 transition-colors"
          aria-label="Supprimer"
        >
          <Trash2 className="size-4 text-zinc-900" />
        </button>
      )}
    </div>
  );
}
